import React, { Component } from "react";
import TabbedInstructionHeader from "./TabbedInstructionHeader";
import NumKeyPad from "./03-ShortTermMemory-KeyPad";
import TextEntry from "./03-ShortTermMemory-TextEntry";
import * as pageData from "./PageData";

/* eslint-disable no-unused-vars */
const tryButton1 = 0;
const displayNumbers1 = 1;
const practice1 = 2;
const done1 = 3;
const tryButton2 = 4;
const displayNumbers2 = 5;
const practice2 = 6;
const done2 = 7;
const completed = 8;
/* eslint-enable */

var digitIndex = 0;
var myVar = null;

var completionText;

export default class ShortTermMemoryInstruction extends Component {
    constructor(props) {
        super(props);
        completionText = pageData.getStandardPracticeCompletedText();
        this.circleClick = this.circleClick.bind(this);
        this.buttonClick = this.buttonClick.bind(this);
        this.textOnFocus = this.textOnFocus.bind(this);
        this.state = {
            innerStep: tryButton1,
            input: ["", "", "", "", "", "", "", "", ""],
            inputIndex: -1,
            timerIndex: 0
        };
    }

    componentWillUnmount() {
        clearTimeout(myVar);
    }

    circleClick(tabId) {
        if (!this.props.waitingForSpeech) {
            this.props.setCurrentTab(tabId);
        }
    }

    setNumbers(numbers) {
        try {
            const timerIndex = this.state.timerIndex;

            if (timerIndex === 99) {
                clearTimeout(myVar);
                myVar = null;
                this.setState({ timerIndex: 100, innerStep: this.state.innerStep + 1, input: ["", "", "", "", "", "", "", "", ""], inputIndex: 0 });
            } else if (timerIndex % 11 === 0) {
                const input = this.state.input;
                input[digitIndex] = numbers[digitIndex];
                this.setState({ input: input, timerIndex: timerIndex + 1 });
            } else if (timerIndex % 11 === 10) {
                const input = this.state.input;
                input[digitIndex++] = "";
                this.setState({ input: input, timerIndex: timerIndex + 1 });
            } else {
                this.setState({ timerIndex: timerIndex + 1 });
            }
        } catch (e) {
            clearTimeout(myVar);
            myVar = null;
            this.setState({ timerIndex: 100, innerStep: this.state.innerStep + 1, input: ["", "", "", "", "", "", "", "", ""], inputIndex: 0 });
        }
    }

    displayNumbers(numbers, devMode) {
        this.setState({ timerIndex: 0 });
        digitIndex = 0;
        myVar = setInterval(this.setNumbers.bind(this, numbers), devMode ? 20 : 100);
    }

    buttonClick(type) {
        const innerStep = this.state.innerStep;
        let inputIndex = this.state.inputIndex;

        if (myVar !== null) {
            //
        } else if (type === "try") {
            this.setState({ innerStep: innerStep + 1, input: ["", "", "", "", "", "", "", "", ""], inputIndex: -1 });

            if (innerStep === tryButton1) {
                this.displayNumbers("123456789", this.props.devMode);
            } else {
                this.displayNumbers("827545963", this.props.devMode);
            }
        }
        else if (type === "done")
        {
            this.setState({ innerStep: innerStep + 1, inputIndex: -1 });

            if (innerStep === done2) {
                this.props.clearDisableNext();
                this.props.playSpeechForInstructionEnd(completionText);
            }
        }
        else if (inputIndex >= 0 && (innerStep === practice1 || innerStep === done1 || innerStep === practice2 || innerStep === done2))
        {
            const input = this.state.input;

            input[inputIndex++] = type;

            if (inputIndex === 9) {
                inputIndex = 8;
            }

            const temp = { input: input, inputIndex: inputIndex };

            if (innerStep === practice1 || innerStep === practice2) {
                let done = true;

                for (let i = 0; i < 9; i++) {
                    if (input[i] === "") {
                        done = false;
                        break;
                    }
                }

                if (done) {
                    temp.innerStep = innerStep + 1;
                }
            }

            this.setState(temp);
        }
    }

    textOnFocus(e, index) {
        e.target.blur();
        this.setState({ inputIndex: index });
    }

    render() {
        const p = this.props;

        return (
<div className="test-page-content-inner test-page-instruction test-page-short-term-memory-instruction" >
    <TabbedInstructionHeader currentTabId={p.currentTabId} elems={p.content.elems[0].elems} circleClick={this.circleClick} />
    <div className="practice-content">
        {renderPractice(p, this.state, this.buttonClick, this.textOnFocus)}
    </div>
</div>
        );
    }
}

function renderPractice(props, state, buttonClick, textOnFocus) {
    if (state.innerStep >= completed) {
        var inner = completionText.map(function (str, index) {
            return (<p key={index + 1}>{str}</p>);
        });

        return (
            <div className="practice-completed">
                <i key="0" className="far fa-check"></i>
                {inner}
            </div>
        );
    }

    const disabled = ((state.innerStep % 4 === 2 && state.timerIndex === 100) || (state.innerStep % 4 === 3)) ? "" : "disabled";

    return (
    <div className="practice-content-inner">
        <div className="practice-col-1">
            <NumKeyPad buttonClick={buttonClick} />
            <TextEntry input={state.input} inputIndex={state.inputIndex} onFocus={textOnFocus} disabled={disabled} />
        </div>
        <div className="practice-col-2">
            {renderPracticeButtons(props, state, buttonClick)}
        </div>
    </div>
    );
}

function renderPracticeButtons(props, state, buttonClick) {
    if (state.innerStep >= completed) {
        return null;
    }

    if (state.innerStep % 4 === 0) {
        return renderTryButton(props, state, buttonClick);
    }

    if (state.innerStep % 4 === 3) {
        return renderOkButton(props, state, buttonClick);
    }

    return null;
}

function renderOkButton(props, state, buttonClick) {
    const disabled = props.waitingForSpeech ? "disabled" : "";
    return (
    <button className="btn btn-secondary btn-try" onClick={() => buttonClick("done")} disabled={disabled}>DONE</button>
    );
}
function renderTryButton(props, state, buttonClick) {
    const disabled = props.waitingForSpeech ? "disabled" : "";
    const label = state.innerStep === tryButton1 ? "TRY" : "TRY AGAIN";
    return (
    <button className="btn btn-secondary btn-try" onClick={() => buttonClick("try")} disabled={disabled}>{label}</button>
    );
}